export default function BoldLabel({text}) {
    return (
    <span class="font-bold text-lg text-black">{text}</span>
    
    )}